import SanityClient from '@sanity/client'

export const sanity = SanityClient({
  projectId: '4h8ytw6p', // find this at manage.sanity.io or in your sanity.json
  dataset: 'production', // this is from those question during 'sanity init'
  useCdn: true,
  apiVersion: '2022-01-17',
})